module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy-Italic.37ab03d4.ttf";